// extracted by mini-css-extract-plugin
module.exports = {"container":"dontShowAgainCheckbox_container__3w8er","checkbox":"dontShowAgainCheckbox_checkbox__3q0IP","label":"dontShowAgainCheckbox_label__ve7m_"};